export function isOperation<T extends Record<string, unknown>>(
  data: unknown
): data is Operation<T> {
  return (
    Object.prototype.hasOwnProperty.call(data, 'operationId') &&
    Object.prototype.hasOwnProperty.call(data, 'entityId') &&
    Object.prototype.hasOwnProperty.call(data, 'state')
  );
}
